import useSWR, { SWRResponse } from "swr";

import fetcher from "../components/helper/fetcher";
import { getWindowOrigin } from "../components/helper/utils";

export default function useSwrApi<T>(endpoint: string): SWRResponse<T> {
  const swrRes: SWRResponse<T> = useSWR<T>(
    `${getWindowOrigin()}/_plat/api/v1/${endpoint}`,
    fetcher,
  );
  return swrRes;
}
